import Vue from 'vue';
import App from './App.vue';
import storeApp from './store/store';

Vue.config.productionTip = false;

// generate svg sprite
import "./assets/icons/_svg-sprite";

// common mixin methods
import {AppMixins} from './components/commonMixin.js';
Vue.mixin(AppMixins);


new Vue({
  render: h => h(App),
  store: storeApp
}).$mount('#brandmark');
